import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import ScrollToTop from "@/components/site/ScrollToTop";
import { useSettings } from "@/context/SettingsContext";

const MarketingLayout = () => {
  const { settings, loading } = useSettings();
  if (loading || !settings) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Carregando…
      </div>
    );
  }
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
};

export default MarketingLayout;
